// Libraries
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// Store
import { store } from './app/store';

// App
import App from './App';
import ErrorBoundary from './ErrorBoundary';

// Utilities
import reportWebVitals from './reportWebVitals';

// Styles
import './index.css';

const container = document.getElementById('root')!;
const root = createRoot(container);
const urlParams = new URLSearchParams(window.location.search);
const authToken = urlParams.get('bred_token');

if (authToken !== null) {
    localStorage.removeItem('apiToken');
    sessionStorage.setItem('authToken', authToken);
    window.history.replaceState({}, document.title, '/play');
}

root.render(
    <StrictMode>
        <ErrorBoundary>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>
    </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
